// extracted by mini-css-extract-plugin
module.exports = {"clubBlockDiscounts__container":"ClubBlockDiscounts_clubBlockDiscounts__container__EH4Ie"};